/**
 * Whether parts are still on their way to the quote: a part of the match list uploading
 * (customer flow), or parts of this quote still queued or uploading in the staff tray.
 * Continue and submit wait for both, so a quote is never sent without its whole batch.
 */
export const hasPartsUploading = (
    fileParts: Array<{ uploading?: boolean }> | undefined,
    pendingUploadsOfQuote: number
): boolean => Boolean(fileParts?.some(part => part.uploading)) || pendingUploadsOfQuote > 0;
